import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import Breadcrumb from "@/components/feature/Breadcrumb";

function formatViews(num: number) {
  if (num >= 10000) return `${(num / 10000).toFixed(1)}万`;
  return num.toString();
}

export default function AboutPage() {
  const totalViews = articles.reduce((sum, a) => sum + a.views, 0);
  const exclusiveCount = articles.filter((a) => a.isExclusive).length;

  return (
    <main>
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于我们 - 爆料网",
          description: "爆料网是专注于网红主播塌房现场、明星反差视频与独家吃瓜内容的爆料资讯聚合平台。",
          url: "http://rbecpr.cn/about",
          mainEntity: {
            "@type": "Organization",
            name: "爆料网",
            alternateName: "911爆料吃瓜网",
            url: "http://rbecpr.cn/",
            logo: "http://rbecpr.cn/logo.png",
            description: "爆料网整合911爆料与91爆料网核心黑料资源，每日实时追踪网红主播塌房现场、明星反差视频与独家吃瓜内容。",
            foundingDate: "2024",
            sameAs: [],
          },
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "首页",
              item: "http://rbecpr.cn/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "关于我们",
              item: "http://rbecpr.cn/about",
            },
          ],
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "爆料网的内容来源可靠吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "爆料网所有内容均经过多源交叉验证，标注信息来源，确保可追溯。我们不制造假料，每一条爆料都力求呈现事实的完整轮廓。",
              },
            },
            {
              "@type": "Question",
              name: "如何向爆料网投稿？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "你可以通过投稿邮箱 hello@rbecpr.cn 发送爆料内容。请确保内容真实可靠，并附上可验证的证据或信息来源。",
              },
            },
            {
              "@type": "Question",
              name: "爆料网会保护投稿人隐私吗？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "我们严格保护所有投稿人的隐私信息。你可以选择匿名投稿，我们将对身份信息进行加密处理，绝不向第三方透露。",
              },
            },
            {
              "@type": "Question",
              name: "发现爆料内容有误怎么办？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "如果你发现任何不准确或错误的信息，请立即通过 hello@rbecpr.cn 联系我们。我们承诺在第一时间核实并更正。",
              },
            },
            {
              "@type": "Question",
              name: "爆料网与911爆料、91爆料网有什么关系？",
              acceptedAnswer: {
                "@type": "Answer",
                text: "爆料网整合911爆料、91爆料网、51爆料网等核心黑料资源，为吃瓜群众提供一站式浏览体验。我们不是这些平台的附属，而是独立的爆料资讯聚合平台。",
              },
            },
          ],
        })}
      </script>

      {/* About Hero */}
      <section className="bg-foreground-950 pt-20 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <Breadcrumb
            items={[{ label: "首页", href: "/" }, { label: "关于我们" }]}
          />
          <div className="mt-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 text-primary-400 text-xs font-medium mb-6">
              <i className="ri-shield-check-line"></i>
              值得信赖的爆料平台
            </div>
            <h1
              className="text-3xl md:text-4xl lg:text-5xl font-black text-background-50 leading-tight mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              让真相
              <span className="text-primary-500">不被掩埋</span>
            </h1>
            <p className="text-base md:text-lg text-background-300 max-w-2xl mx-auto leading-relaxed">
              爆料网成立于2024年，是专注于网红主播塌房现场、明星反差视频与独家吃瓜内容的爆料资讯聚合平台。我们整合911爆料、91爆料网、51爆料网等核心黑料资源，为吃瓜群众提供最有价值的爆料内容。
            </p>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-10 md:py-14 bg-background-100">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { num: "500+", label: "每日爆料", icon: "ri-article-line" },
              { num: formatViews(totalViews), label: "总浏览量", icon: "ri-eye-line" },
              { num: articles.length.toString(), label: "爆料文章", icon: "ri-file-list-3-line" },
              { num: exclusiveCount.toString(), label: "独家报道", icon: "ri-vip-crown-line" },
            ].map((stat) => (
              <div
                key={stat.label}
                className="bg-background-50 rounded-lg p-5 text-center"
              >
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-primary-500 text-lg`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-black text-foreground-950 mb-1">
                  {stat.num}
                </div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-center">
            <div className="w-full md:w-1/2">
              <h2
                className="text-2xl md:text-3xl font-black text-foreground-950 mb-6"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                品牌故事
              </h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  爆料网诞生于一个简单却强烈的信念：在信息爆炸的时代，真相不应该被掩埋，吃瓜群众有权知道事实的完整轮廓。
                </p>
                <p>
                  我们注意到，911爆料、91爆料网、51爆料网等平台分散了太多有价值的爆料内容，用户需要在多个平台间来回切换才能获取完整信息。爆料网应运而生，致力于整合全网核心黑料资源，打造一站式吃瓜体验。
                </p>
                <p>
                  从最初的一个小众爆料聚合站，到如今拥有数百万日活用户的爆料资讯平台，爆料网始终坚持"不夸大、不捏造、不缺席"的编辑原则，为吃瓜群众筛选最有价值的爆料内容。
                </p>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20newsroom%20with%20multiple%20computer%20screens%20showing%20breaking%20news%2C%20team%20of%20investigative%20journalists%20working%2C%20dramatic%20red%20and%20black%20lighting%2C%20dark%20moody%20atmosphere%2C%20professional%20media%20production%20environment%2C%20cinematic%20documentary%20style&width=800&height=600&seq=about-team&orientation=landscape"
                alt="爆料网团队"
                className="w-full rounded-lg object-cover aspect-[4/3]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Team / Credibility */}
      <section id="team" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center">
            <div className="w-full md:w-2/5">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20female%20editor%20in%20modern%20office%2C%20confident%20expression%2C%20holding%20tablet%20device%2C%20dramatic%20side%20lighting%2C%20high%20contrast%20portrait%20style%2C%20editorial%20photography%2C%20dark%20professional%20attire&width=600&height=700&seq=about-editor&orientation=portrait"
                alt="爆料网创始人"
                className="w-full rounded-lg object-cover aspect-[4/5]"
                loading="lazy"
              />
            </div>
            <div className="w-full md:w-3/5">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-1.5 h-1.5 rounded-full bg-foreground-950"></div>
                <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  团队背书
                </span>
              </div>
              <blockquote
                className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-relaxed mb-6"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                <span className="text-primary-500 text-4xl">"</span>
                我们不做谣言的传播者，而是真相的拼图者。每一条爆料都经过多源验证，确保吃瓜群众看到的是最真实、最完整的事实。
              </blockquote>
              <div className="flex items-center gap-3 mb-8">
                <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                  <i className="ri-user-3-line text-secondary-700"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-950">
                    林总监
                  </div>
                  <div className="text-xs text-foreground-400 flex items-center gap-1">
                    爆料网内容总监
                    <i className="ri-checkbox-circle-fill text-green-500"></i>
                  </div>
                </div>
              </div>
              <div className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200">
                <h3 className="text-sm font-bold text-foreground-800 mb-3">
                  我们的新闻准则
                </h3>
                <ul className="space-y-2.5">
                  {[
                    "所有爆料内容均标注信息来源，可追溯可验证",
                    "不制造假料、不夸大事实、不煽动情绪",
                    "尊重当事人隐私，仅曝光与公共利益相关的内容",
                    "第一时间更正错误信息，保持内容准确性",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-check-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Submit Guide */}
      <section id="submit" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2
            className="text-2xl md:text-3xl font-black text-foreground-950 mb-4"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            投稿须知
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-10 max-w-2xl mx-auto">
            如果你有真实的爆料内容想要分享，请仔细阅读以下投稿须知，确保你的爆料符合我们的发布标准。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 text-left">
            {[
              {
                icon: "ri-shield-check-line",
                title: "真实性",
                desc: "投稿内容必须真实可靠，需提供可验证的证据或信息来源。捏造、编造的内容将不予采纳。",
              },
              {
                icon: "ri-file-list-3-line",
                title: "完整性",
                desc: "请尽量提供完整的事件经过、时间线和相关证据。信息越完整，爆料价值越高。",
              },
              {
                icon: "ri-user-follow-line",
                title: "合法性",
                desc: "投稿内容不得涉及违法信息，不得侵犯他人隐私权、名誉权等合法权益。",
              },
            ].map((item) => (
              <div
                key={item.title}
                className="bg-background-100 rounded-lg p-5 md:p-6"
              >
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-primary-500 text-lg`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="text-center mb-10">
            <h2
              className="text-2xl md:text-3xl font-black text-foreground-950 mb-3"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              关于爆料网，你想知道的一切
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                q: "爆料网的内容来源可靠吗？",
                a: "爆料网所有内容均经过多源交叉验证，标注信息来源，确保可追溯。我们不制造假料，每一条爆料都力求呈现事实的完整轮廓。",
              },
              {
                q: "如何向爆料网投稿？",
                a: "你可以通过投稿邮箱 hello@rbecpr.cn 发送爆料内容。请确保内容真实可靠，并附上可验证的证据或信息来源。",
              },
              {
                q: "爆料网会保护投稿人隐私吗？",
                a: "我们严格保护所有投稿人的隐私信息。你可以选择匿名投稿，我们将对身份信息进行加密处理，绝不向第三方透露。",
              },
              {
                q: "发现爆料内容有误怎么办？",
                a: "如果你发现任何不准确或错误的信息，请立即通过 hello@rbecpr.cn 联系我们。我们承诺在第一时间核实并更正。",
              },
              {
                q: "爆料网与911爆料、91爆料网有什么关系？",
                a: "爆料网整合911爆料、91爆料网、51爆料网等核心黑料资源，为吃瓜群众提供一站式浏览体验。我们不是这些平台的附属，而是独立的爆料资讯聚合平台。",
              },
            ].map((faq, idx) => (
              <details
                key={idx}
                className="group bg-background-50 rounded-lg border border-background-200 open:border-primary-200 transition-colors"
              >
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <span className="text-sm md:text-base font-bold text-foreground-950 pr-4">
                    {faq.q}
                  </span>
                  <span className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                    <i className="ri-add-line text-foreground-500 group-open:hidden"></i>
                    <i className="ri-subtract-line text-primary-500 hidden group-open:block"></i>
                  </span>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-16 md:py-20 bg-foreground-950">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2
            className="text-2xl md:text-3xl font-black text-background-50 mb-4"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            联系我们
          </h2>
          <p className="text-sm md:text-base text-background-300 mb-10 max-w-xl mx-auto">
            无论是爆料投稿、商务合作还是意见建议，我们都欢迎你的联系。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
            {[
              {
                icon: "ri-mail-line",
                title: "投稿邮箱",
                info: "hello@rbecpr.cn",
              },
              {
                icon: "ri-briefcase-line",
                title: "商务合作",
                info: "hello@rbecpr.cn",
              },
              {
                icon: "ri-customer-service-line",
                title: "意见建议",
                info: "hello@rbecpr.cn",
              },
            ].map((contact) => (
              <div
                key={contact.title}
                className="bg-foreground-900/50 rounded-lg p-5 md:p-6 border border-foreground-800"
              >
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center mx-auto mb-3">
                  <i className={`${contact.icon} text-primary-400 text-lg`}></i>
                </div>
                <h3 className="text-sm font-bold text-background-200 mb-1">
                  {contact.title}
                </h3>
                <p className="text-sm text-background-400">{contact.info}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-bold hover:bg-primary-600 transition-colors"
            >
              返回首页
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section id="disclaimer" className="py-10 md:py-12 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h3 className="text-sm font-bold text-foreground-800 mb-3">
            免责声明
          </h3>
          <p className="text-xs md:text-sm text-foreground-400 leading-relaxed">
            爆料网所有内容均来源于网络及用户投稿，仅供娱乐参考，不代表本站立场和观点。本站不对内容的准确性、完整性、及时性做任何担保。如涉及侵权或虚假信息，请与我们联系，我们将在第一时间核实处理。用户在浏览本站内容时应保持理性判断，切勿盲目传播未经证实的信息。
          </p>
        </div>
      </section>
    </main>
  );
}
